import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

const store = {
  namespaced: true,
  state() {
    return {
      lists: [],
      campaignsMJ: [],
    };
  },
  actions,
  getters,
  mutations,
};

export default store;
